import ozBusinessType from './oz-business-type.vue'

export default ozBusinessType
